"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notLoggedInErrorMessage = void 0;
exports.notLoggedInErrorMessage = "User not logged in";
//# sourceMappingURL=messages.js.map